import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useEffect } from 'react';
import { Combobox } from '@flywire/react-headlessui';
import { useInputClasses } from '../Field';
import { useComboboxContext } from './Combobox';
const InputComponent = forwardRef(({ placeholder, className, position, ...rest }, ref) => {
    const { inputRef } = useComboboxContext();
    const { floatingLabel } = useComboboxContext();
    const inputClasses = useInputClasses({ floatingLabel, className, position });
    useEffect(() => {
        if (ref) {
            if (typeof ref === 'function') {
                ref(inputRef.current);
            }
            else {
                ref.current = inputRef.current;
            }
        }
    }, [ref, inputRef]);
    return (_jsx(Combobox.Input, { placeholder: placeholder, className: inputClasses, ref: inputRef, ...rest }));
});
InputComponent.displayName = 'Input';
export { InputComponent as Input };
//# sourceMappingURL=Input.js.map